import { ref } from 'vue'

export const messageRegisterEmpty = {
  message: '',
  class: '',
  errors: []
}

interface IMessageRegister {
  message: string
  class?: string
  errors?: string[]
}
export const messageRegister = ref<IMessageRegister>(messageRegisterEmpty)
export const showMessageRegister = ref(false)
